export default __webpack_public_path__ + "static/media/18.8e641f16.jpg";